import React from 'react';
import './PlanCard.less';
import { Button } from 'antd';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import {
  BillingAdvancedStarsIcon,
  BillingEnterpriseIcon,
  CheckIcon
} from '@icons';
import {
  toggleBillingModal,
  toggleCancelSubscriptionModal,
  toggleChangePlanDetailsModal
} from '@redux/actions/modalAction';

interface PlanCardProps {
  name: string;
  description: string;
  price?: string | number | null;
  buttonText: string;
  isButtonDisabled: boolean;
  offerTitle: string;
  offerServicesList: string[];
  value: 'free' | 'starter' | 'team' | 'enterprise';
  paymentMethod: 'monthly' | 'annually';
}

function PlanCard({
  name,
  description,
  price,
  buttonText,
  isButtonDisabled,
  offerTitle,
  offerServicesList,
  value,
  paymentMethod
}: PlanCardProps) {
  const dispatch = useDispatch();
  return (
    <div
      className={classNames(
        'plan-card-container',
        value === 'team' && 'advanced-plan-card-container'
      )}
    >
      {value === 'team' && (
        <div className="advanced-container">
          <BillingAdvancedStarsIcon />
          <span>Our most popular plan</span>
        </div>
      )}
      <span className="plan-name">{name}</span>
      <span className="plan-description">{description}</span>
      {price !== undefined && price !== null && (
        <div className="price-container">
          <span>${price}</span>
          <span>/ per month</span>
        </div>
      )}
      {value === 'enterprise' && (
        <div className="enterprise-icon-container">
          <BillingEnterpriseIcon />
        </div>
      )}

      <Button
        className="button"
        disabled={isButtonDisabled}
        onClick={async () => {
          if (value === 'free') {
            dispatch(toggleCancelSubscriptionModal({ visible: true }));
          } else if (value === 'enterprise') {
            window.open('https://www.streamwork.com/contact', '_blank');
          } else {
            dispatch(
              toggleChangePlanDetailsModal({
                visible: true,
                paymentMethod,
                value
              })
            );
          }
          dispatch(toggleBillingModal(null));
        }}
      >
        {buttonText}
      </Button>
      <div className="offer-container">
        <span>{offerTitle}</span>
        {offerServicesList.map((item, idx) => {
          if (!item) return;
          return (
            <div className="offer-services-item" key={idx}>
              <CheckIcon className="plan-features-list_icon-active" />
              <span>{item}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default PlanCard;
